import React from "react";
import SectionOne from "./sectionOne/Index";
import SectionTwo from "./sectionTwo/Index";

const Index = () => {
  return (
    <>
      <SectionOne />
      <SectionTwo />
    </>
  );
};

export default Index;
